import moment from 'moment';
import { setRemarketingTag } from 'ha/modules/Analytics/actions';

import { ERROR_MESSAGES } from 'ha/pages/Talk/constants/Errors';
import { ACCEPT } from '../constants/Actions';
import { makeRequestAction } from './actions';

export default conversationId => (dispatch, _, { apiV2 }) => {
  dispatch(makeRequestAction.start({ type: ACCEPT }));

  return apiV2
    .acceptTenant(conversationId)
    .then(({ data }) =>
      apiV2
        .getConversationMessages(conversationId)
        .then(messages => [data, messages]),
    )
    .then(
      ([
        data,
        {
          data: { messages },
        },
      ]) => {
        dispatch(
          setRemarketingTag({
            hrental_id: data.listingId,
            hrental_pagetype: 'proposalsent',
            hrental_startdate: moment(data.startDate).format('YYYY-MM-DD'),
            hrental_enddate: moment(data.endDate).format('YYYY-MM-DD'),
            hrental_totalvalue: data.total,
          }),
        );

        dispatch(makeRequestAction.done({ ...data, messages }));
      },
    )
    .catch(({ cause }) => {
      if (
        cause?.response?.errors?.some(
          error => error.detail === 'startDate should not be in the past',
        )
      ) {
        dispatch(
          makeRequestAction.error(ERROR_MESSAGES.startDateInThePastAdvertiser),
        );
      } else if (
        cause?.response?.errors?.some(
          error => error.detail === 'startDate should be before end date',
        )
      ) {
        dispatch(
          makeRequestAction.error(ERROR_MESSAGES.startDateBeforeEndDate),
        );
      } else {
        dispatch(makeRequestAction.error(ERROR_MESSAGES.DEFAULT));
      }
    });
};
